var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "section",
      class: { selected: _vm.isSelected },
      on: { click: _vm.showAppDetails }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-image app-image-icon",
          on: { click: _vm.showAppDetails }
        },
        [
          (_vm.listView && !_vm.app.preview) ||
          (!_vm.listView && !_vm.app.screenshot)
            ? _c("div", { staticClass: "icon-settings-dark" })
            : _vm._e(),
          _vm._v(" "),
          _vm.listView && _vm.app.preview
            ? _c(
                "svg",
                { attrs: { width: "32", height: "32", viewBox: "0 0 32 32" } },
                [
                  _c("defs", [
                    _c(
                      "filter",
                      { attrs: { id: _vm.filterId } },
                      [
                        _c("feColorMatrix", {
                          attrs: {
                            in: "SourceGraphic",
                            type: "matrix",
                            values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("image", {
                    staticClass: "app-icon",
                    attrs: {
                      x: "0",
                      y: "0",
                      width: "32",
                      height: "32",
                      preserveAspectRatio: "xMinYMin meet",
                      filter: _vm.filterUrl,
                      "xlink:href": _vm.app.preview
                    }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.listView && _vm.app.screenshot
            ? _c("img", { attrs: { src: _vm.app.screenshot, width: "100%" } })
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "app-name", on: { click: _vm.showAppDetails } },
        [_vm._v("\n\t\t" + _vm._s(_vm.app.name) + "\n\t")]
      ),
      _vm._v(" "),
      !_vm.listView
        ? _c("div", { staticClass: "app-summary" }, [
            _vm._v("\n\t\t" + _vm._s(_vm.app.summary) + "\n\t")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.listView
        ? _c("div", { staticClass: "app-version" }, [
            _vm.app.version
              ? _c("span", [_vm._v(_vm._s(_vm.app.version))])
              : _vm.app.appstoreData.releases[0].version
              ? _c("span", [
                  _vm._v(_vm._s(_vm.app.appstoreData.releases[0].version))
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "app-level" },
        [
          _vm.app.level === 300
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.auto",
                      value: _vm.t(
                        "settings",
                        "This app is supported via your current Nextcloud subscription."
                      ),
                      expression:
                        "t('settings', 'This app is supported via your current Nextcloud subscription.')",
                      modifiers: { auto: true }
                    }
                  ],
                  staticClass: "supported icon-checkmark-color"
                },
                [_vm._v("\n\t\t\t" + _vm._s(_vm.t("settings", "Supported")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.app.level === 200
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.auto",
                      value: _vm.t(
                        "settings",
                        "Featured apps are developed by and within the community. They offer central functionality and are ready for production use."
                      ),
                      expression:
                        "t('settings', 'Featured apps are developed by and within the community. They offer central functionality and are ready for production use.')",
                      modifiers: { auto: true }
                    }
                  ],
                  staticClass: "official icon-checkmark"
                },
                [_vm._v("\n\t\t\t" + _vm._s(_vm.t("settings", "Featured")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRating && !_vm.listView
            ? _c("AppScore", { attrs: { score: _vm.app.score } })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "actions" }, [
        _vm.app.error
          ? _c("div", { staticClass: "warning" }, [
              _vm._v("\n\t\t\t" + _vm._s(_vm.app.error) + "\n\t\t")
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.loading(_vm.app.id)
          ? _c("div", { staticClass: "icon icon-loading-small" })
          : _vm._e(),
        _vm._v(" "),
        _vm.app.update
          ? _c("input", {
              staticClass: "update primary",
              attrs: {
                type: "button",
                value: _vm.t("settings", "Update to {update}", {
                  update: _vm.app.update
                }),
                disabled: _vm.installing || _vm.loading(_vm.app.id)
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.update(_vm.app.id)
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.app.canUnInstall
          ? _c("input", {
              staticClass: "uninstall",
              attrs: {
                type: "button",
                value: _vm.t("settings", "Remove"),
                disabled: _vm.installing || _vm.loading(_vm.app.id)
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.remove(_vm.app.id)
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.app.active
          ? _c("input", {
              staticClass: "enable",
              attrs: {
                type: "button",
                value: _vm.t("settings", "Disable"),
                disabled: _vm.installing || _vm.loading(_vm.app.id)
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.disable(_vm.app.id)
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.app.active && (_vm.app.canInstall || _vm.app.isCompatible)
          ? _c("input", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.auto",
                  value: _vm.enableButtonTooltip,
                  expression: "enableButtonTooltip",
                  modifiers: { auto: true }
                }
              ],
              staticClass: "enable",
              attrs: {
                type: "button",
                value: _vm.enableButtonText,
                disabled:
                  !_vm.app.canInstall ||
                  _vm.installing ||
                  _vm.loading(_vm.app.id)
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.enable(_vm.app.id)
                }
              }
            })
          : !_vm.app.active
          ? _c("input", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.auto",
                  value: _vm.forceEnableButtonTooltip,
                  expression: "forceEnableButtonTooltip",
                  modifiers: { auto: true }
                }
              ],
              staticClass: "enable force",
              attrs: {
                type: "button",
                value: _vm.forceEnableButtonText,
                disabled: _vm.installing || _vm.loading(_vm.app.id)
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.forceEnable(_vm.app.id)
                }
              }
            })
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }